<div class="myorders-container">
    <div *ngIf="!isProductScreenVisible" class="order-table-container">
        <div
            *ngFor="let myorder of orderList"
            class="orders-table"
        >
            <div *ngIf="myorder.order?.orderReference!==null" class="field-container">
                <div class="field">
                    <span>Rendelési azonosító</span>
                    <div class="data">
                        <span>{{ myorder.order?.orderReference! }}</span>
                    </div>
                </div>
            </div>
            <div class="field-container">
                <div class="field">
                    <span>Rendelési alazonosító</span>
                    <div class="data">
                        <span>{{ myorder.orderDetailReference }}</span>
                    </div>
                </div>
            </div>
            <div *ngIf="myorder.preOrder" class="field-container">
                <div class="field">
                    <span>Rendelés típusa</span>
                    <div class="data">
                        <span>{{"myOrders.preOrder" | translate}}</span>
                    </div>
                </div>
            </div>
            <div class="field-container">
                <div class="field">
                    <span>Rendelés dátuma</span>
                    <div class="data">
                        <span>{{myorder.insertedTimestampp}}</span>
                    </div>
                </div>
            </div>
            <div class="field-container">
                <div class="field">
                    <span>Megrendelt termékek</span>
                    <div class="data">
                        <button (click)="getProducts(myorder!)">Megrendelt termékek</button>
                    </div>
                </div>
            </div>
            <div class="field-container">
                <div class="field">
                    <span>Rendelés státusza</span>
                    <div class="data">
                        <span>{{'order.' + myorder.status | translate | uppercase }}</span>
                    </div>
                </div>
            </div>
            <div class="field-container">
                <div class="field">
                    <span>Végösszeg</span>
                    <div class="data">
                        {{myorder.totalPrice | currency : 'Ft' : 'symbol' : '1.0-0'}}
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="isProductScreenVisible" class="product-container">
        <div class="product" *ngFor="let product of storeOrderedProductsList">
            <div class="field-container">
                <div class="field">
                    <span>Szerző</span>
                    <div class="data">
                        <span>{{ product.author }}</span>
                    </div>
                </div>
            </div>
            <div class="field-container">
                <div class="field">
                    <span>Cím</span>
                    <div class="data">
                        <span>{{ product.title }}</span>
                    </div>
                </div>
            </div>
            <div *ngIf="preOrder" class="field-container">
                <div class="field">
                    <span>Rendelés típusa</span>
                    <div class="data">
                        <span>{{ "myOrders.preOrder" | translate }}</span>
                    </div>
                </div>
            </div>
            <div class="field-container">
                <div class="field">
                    <span>Várható megjelenés</span>
                    <div class="data">
                        <span>{{ product.available | date }}</span>
                    </div>
                </div>
            </div>
            <div class="field-container">
                <div class="field">
                    <span>Rendelési mennyiség</span>
                    <div class="data">
                        <span>{{ product.quantity }}</span>
                    </div>
                </div>
            </div>
            <div *ngIf="product.packageName" class="field-container">
                <div class="field">
                    <span>Csomag neve</span>
                    <div class="data">
                        <span>{{ product.packageName }}</span>
                    </div>
                </div>
            </div>
            <div *ngIf="!product.packageName" class="field-container">
                <div class="field">
                    <span>Csomag neve</span>
                    <div class="data">
                        <span>-</span>
                    </div>
                </div>
            </div>
            <div class="field-container">
                <div class="field">
                    <span>Ár</span>
                    <div class="data">
                        <span>{{ product.price!*product.quantity! | currency : 'Ft' : 'symbol' : '1.0-0' }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div *ngIf="isProductScreenVisible" class="total-price-main-container">
        <div *ngIf="deliveryOption === 'FOXPOST' || deliveryOption === 'PACKETA'" class="delivery">
            <div class="delivery-text">{{deliveryOption}}</div>
            <div class="delivery-fee">{{deliveryFee | currency : 'Ft' : 'symbol' : '1.0-0'}}</div>
        </div>
        <div class="total-price">
            <div class="total-price-text">VÉGÖSSZEG</div>
            <div class="total-price-value">{{totalPrice | currency : 'Ft' : 'symbol' : '1.0-0' }}</div>
        </div>
    </div>
    <div *ngIf="isProductScreenVisible" class="back-to-orders">
        <button (click)="backToOrders()">Vissza a rendelési listához</button>
    </div>
</div>


